import { supabase } from "~/integrations/supabase/ssr.browser";
import { logger } from "~/lib/logger";

// AIDEV-NOTE: Centralized logout utility for consistent SSR-based logout
export async function handleLogout() {
    try {
        await supabase.auth.signOut();
    } catch (error) {
        logger
            .withError(error as Error)
            .warn(
                "Supabase client signOut failed; proceeding with server logout",
            );
    }

    try {
        await fetch("/api/auth/logout", {
            method: "POST",
            credentials: "include",
        });
    } catch (error) {
        logger
            .withError(error as Error)
            .error("Failed to logout via server endpoint");
    }

    // Hard refresh to clear all caches & data
    window.location.href = "/landing";
}
